import { ArrowNarrowLeftIcon } from "@heroicons/react/outline"
import React from "react"
import { Link } from "react-router-dom"

export default function Error() {
	return (
		<>
			<section className='container mx-auto space-y-4 '>
				<div className='grid  sm:grid-cols-2 justify-center items-center gap-4'>
					<div className='p-4'>
						<div className='flex justify-between items-center'>
							<div className='flex justify-start gap-x-2 flex-1'>
								<img className='h-32 sm:h-auto w-32 sm:w-auto mx-auto object-contain ' src='/images/404.png' alt='Website Logo' />
							</div>
						</div>
					</div>

					<div className='p-2 sm:p-4'>
						<div className='flex justify-between items-center'>
							<div className='gap-x-2 flex-1 '>
								<div className='flex flex-col justify-between space-y-1 sm:space-y-3 items-center'>
									<p className='text-base sm:text-2xl font-medium text-gray-700'>404!</p>

									<h3 className=' text-2xl sm:text-4xl font-bold text-gray-700'>You are beyond </h3>

									<h3 className='text-2xl  sm:text-4xl font-bold text-gray-700'>the border!</h3>

									<div className='text-xs sm:text-sm text-center'>
										<p>It looks like you have reached to a URL that doesn’t exist!</p>
										<p>
											Please use the navigation above to find your way
											<Link className='text-[#3076CE] font-bold' to={"/"}>
												{" "}
												“Home”
											</Link>{" "}
											.
										</p>
									</div>

									<button type='submit' className=' flex justify-between  text-white font-medium text-xs sm:text-sm px-4 py-2 rounded-lg shadow-lg  bg-[#2995FC] '>
										<ArrowNarrowLeftIcon className='h-5 w-5 mr-1' />

										<Link to={"/"}>Go Back To Home</Link>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* <Error500 /> */}
		</>
	)
}
